import { UNITS } from "./units";
import { ControlType, Field, Section } from "@cotecna/dynamic-view-engine";
import { ITEM_TYPES } from "./item-types";

const NEW_MULTIPLE_PRODUCTS_FIELDS: Field[] = [
  {
    id: "type",
    type: ControlType.Dropdown,
    label: "Item Type",
    order: 1,
    propertyName: "type",
    value: "",
    required: true,
    visible: true,
    valid: false,
  },
  {
    id: "amount",
    type: ControlType.NumericInput,
    label: "Amount",
    order: 2,
    propertyName: "amount",
    value: "",
    required: true,
    visible: true,
    valid: false,
  },
  {
    id: "quantity",
    type: ControlType.NumericInput,
    label: "Expected Quantity",
    order: 3,
    propertyName: "quantity",
    value: "",
    required: false,
    visible: true,
    valid: true,
  },
  {
    id: "unit",
    type: ControlType.Dropdown,
    label: "Unit",
    order: 4,
    propertyName: "unit",
    value: "UNT",
    readableValue: "UNT",
    required: false,
    visible: true,
    valid: true,
  },
  {
    id: "form",
    type: ControlType.Dropdown,
    label: "Form",
    order: 5,
    propertyName: "form",
    value: "",
    required: true,
    visible: true,
    valid: false,
  },
];

export const NEW_MULTIPLE_PRODUCTS_FORM: Section[] = [
  {
    id: "1",
    name: "",
    isFixed: true,
    order: 1,
    fields: NEW_MULTIPLE_PRODUCTS_FIELDS,
    actions: [],
  },
];

export const NEW_MULTIPLE_PRODUCTS_CONTROLS: any[] = [
  {
    id: "type",
    maxLength: 50,
    options: ITEM_TYPES,
  },
  {
    id: "amount",
  },
  {
    id: "quantity",
  },
  {
    id: "unit",
    options: UNITS,
  },
  {
    id: "form",
    options: [],
  },
];
